/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeviceUptimeSummary
 */
export interface DeviceUptimeSummary {
    /**
     * Device identity
     * @type {string}
     * @memberof DeviceUptimeSummary
     */
    deviceIdentity?: string;
    /**
     * Device friendly name
     * @type {string}
     * @memberof DeviceUptimeSummary
     */
    friendlyName?: string;
    /**
     * Number of connectors on this device
     * @type {number}
     * @memberof DeviceUptimeSummary
     */
    connectorCount?: number;
    /**
     * Device uptime percentage (0-1). Offline periods are not considered.
     * @type {number}
     * @memberof DeviceUptimeSummary
     */
    uptimeOfflineIncluded?: number;
    /**
     * Device uptime percentage (0-1). Offline periods are removed from calculation.
     * @type {number}
     * @memberof DeviceUptimeSummary
     */
    uptimeOfflineExcluded?: number;
    /**
     * Preferred uptime based on organisation preference.
     * @type {number}
     * @memberof DeviceUptimeSummary
     */
    preferredUptime?: number;
    /**
     * Whether offline is included in preferred calculation.
     * @type {boolean}
     * @memberof DeviceUptimeSummary
     */
    isOfflineIncluded?: boolean;
    /**
     * Parent site device group tag
     * @type {string}
     * @memberof DeviceUptimeSummary
     */
    siteGroupTag?: string;
    /**
     * Parent site name
     * @type {string}
     * @memberof DeviceUptimeSummary
     */
    siteName?: string;
    /**
     * Parent organisation device group tag
     * @type {string}
     * @memberof DeviceUptimeSummary
     */
    orgGroupTag?: string;
    /**
     * Parent organisation name
     * @type {string}
     * @memberof DeviceUptimeSummary
     */
    orgName?: string;
    /**
     * Service model device group tag
     * @type {string}
     * @memberof DeviceUptimeSummary
     */
    serviceModelGroupTag?: string;
    /**
     * Service model name
     * @type {string}
     * @memberof DeviceUptimeSummary
     */
    serviceModelName?: string;
    /**
     * Device model (hardware model identifier)
     * @type {string}
     * @memberof DeviceUptimeSummary
     */
    deviceModel?: string;
    /**
     * All device group tags this device belongs to (for OData filtering)
     * @type {Array<string>}
     * @memberof DeviceUptimeSummary
     */
    deviceGroupTags?: Array<string>;
    /**
     * Calculation period start
     * @type {Date}
     * @memberof DeviceUptimeSummary
     */
    periodStart?: Date;
    /**
     * Calculation period end
     * @type {Date}
     * @memberof DeviceUptimeSummary
     */
    periodEnd?: Date;
}

/**
 * Check if a given object implements the DeviceUptimeSummary interface.
 */
export function instanceOfDeviceUptimeSummary(
    value: object,
): value is DeviceUptimeSummary {
    return true;
}

export function DeviceUptimeSummaryFromJSON(json: any): DeviceUptimeSummary {
    return DeviceUptimeSummaryFromJSONTyped(json, false);
}

export function DeviceUptimeSummaryFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceUptimeSummary {
    if (json == null) {
        return json;
    }
    return {
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        friendlyName:
            json["friendlyName"] == null ? undefined : json["friendlyName"],
        connectorCount:
            json["connectorCount"] == null ? undefined : json["connectorCount"],
        uptimeOfflineIncluded:
            json["uptimeOfflineIncluded"] == null
                ? undefined
                : json["uptimeOfflineIncluded"],
        uptimeOfflineExcluded:
            json["uptimeOfflineExcluded"] == null
                ? undefined
                : json["uptimeOfflineExcluded"],
        preferredUptime:
            json["preferredUptime"] == null
                ? undefined
                : json["preferredUptime"],
        isOfflineIncluded:
            json["isOfflineIncluded"] == null
                ? undefined
                : json["isOfflineIncluded"],
        siteGroupTag:
            json["siteGroupTag"] == null ? undefined : json["siteGroupTag"],
        siteName: json["siteName"] == null ? undefined : json["siteName"],
        orgGroupTag:
            json["orgGroupTag"] == null ? undefined : json["orgGroupTag"],
        orgName: json["orgName"] == null ? undefined : json["orgName"],
        serviceModelGroupTag:
            json["serviceModelGroupTag"] == null
                ? undefined
                : json["serviceModelGroupTag"],
        serviceModelName:
            json["serviceModelName"] == null
                ? undefined
                : json["serviceModelName"],
        deviceModel:
            json["deviceModel"] == null ? undefined : json["deviceModel"],
        deviceGroupTags:
            json["deviceGroupTags"] == null
                ? undefined
                : json["deviceGroupTags"],
        periodStart:
            json["periodStart"] == null
                ? undefined
                : new Date(json["periodStart"]),
        periodEnd:
            json["periodEnd"] == null ? undefined : new Date(json["periodEnd"]),
    };
}

export function DeviceUptimeSummaryToJSON(
    value?: DeviceUptimeSummary | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceIdentity: value["deviceIdentity"],
        friendlyName: value["friendlyName"],
        connectorCount: value["connectorCount"],
        uptimeOfflineIncluded: value["uptimeOfflineIncluded"],
        uptimeOfflineExcluded: value["uptimeOfflineExcluded"],
        preferredUptime: value["preferredUptime"],
        isOfflineIncluded: value["isOfflineIncluded"],
        siteGroupTag: value["siteGroupTag"],
        siteName: value["siteName"],
        orgGroupTag: value["orgGroupTag"],
        orgName: value["orgName"],
        serviceModelGroupTag: value["serviceModelGroupTag"],
        serviceModelName: value["serviceModelName"],
        deviceModel: value["deviceModel"],
        deviceGroupTags: value["deviceGroupTags"],
        periodStart:
            value["periodStart"] == null
                ? undefined
                : value["periodStart"].toISOString(),
        periodEnd:
            value["periodEnd"] == null
                ? undefined
                : value["periodEnd"].toISOString(),
    };
}
